import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';



// type EntityResponseType = HttpResponse;
// type EntityArrayResponseType = HttpResponse<IPolicyMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class CertificateMySuffixService {

    private resourceUrl = SERVER_API_URL + 'api/certificate';
    private clientRUrl = SERVER_API_URL + 'api/certificate-clients';
    private downloadAllClausesUrl = SERVER_API_URL + 'api/download-certificate-clause';
    private downloadAllExtensionUrl = SERVER_API_URL + 'api/download-certificate-extension';
    private clientAllUrl = SERVER_API_URL + 'api/certificate-clients-all';
    constructor(private http: HttpClient) { }

    create(url: any): Observable<any> {
        return this.http.post<any>(this.resourceUrl + url, { observe: 'response' }).map((res: any) => res);
    }

    scopeCreate(url, scope: any): Observable<any> {
        return this.http.post<any>(SERVER_API_URL + url, scope, { observe: 'response' }).map((res: any) => res);
    }

    currencyConverstion(url?: any): Observable<any> {
        return this.http.get(SERVER_API_URL + url, { observe: 'response' }).map((res: any) => res);
    }

    getClientAddress(req?: any): Observable<any> {
        const addressURL = SERVER_API_URL + 'api/certificate/get-client-Details';
        return this.http.get<any[]>(addressURL, { observe: 'response' });
    }

    checkIMONumber(imoNumber: any, scopeId: any): Observable<any> {
        const addressURL = SERVER_API_URL + 'api/certificate-request/' + imoNumber + '/validate/' + scopeId;
        return this.http.get<any[]>(addressURL, { observe: 'response' });
    }

    // find(id: number): Observable<EntityResponseType> {
    //     return this.http
    //         .get<IPolicyMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' })
    //         .map((res: EntityResponseType) => this.convertDateFromServer(res));
    // }

    query(url?: any, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http
            .get(this.resourceUrl + url, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));
    }

    // queryWithIdForFFClient(url?: any, id?: number, req?: any): Observable<any> {
    //     const options = createRequestOption(req);
    //     return this.http
    //          .get(`${this.resourceUrl + url}/${id}`, { params: options, observe: 'response' })
    //         .map((res: any) => this.convertDateArrayFromServer(res));
    // }

    queryWithId(url?: any, id?: number, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http
            .get(`${this.resourceUrl + url}/${id}`, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));
    }

    find(id: number): Observable<any> {
        return this.http.get<any>(`${this.clientRUrl}/${id}`, { observe: 'response' });
        // .map((res: any) => this.convertDateArrayFromServer(res));
    }

    findCertificateClient(id: number): Observable<any> {
        const addressURL = SERVER_API_URL + 'api/certificate-client-active/' + id;
        return this.http.get<any>(addressURL, { observe: 'response' });
        // .map((res: any) => this.convertDateArrayFromServer(res));
    }

    getById(url?: any, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http
            .get(SERVER_API_URL + url, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));
    }


    private convertDateArrayFromServer(res: any): any {
        return res.body;
    }

    postData(data: any, url: any): Observable<any> {
        return this.http.post<any>(url, data, { observe: 'response' });
    }

    post(data: any, url: any): Observable<any> {
        return this.http.post<any>(SERVER_API_URL + url, data, { observe: 'response' });
    }

    getCancelCertificate(url?: any): Observable<any> {
        return this.http.get<any[]>(url, { observe: 'response' });
    }

    getConfirmCertificate(url?: any): Observable<any> {
        return this.http.get<any[]>(url, { observe: 'response' });
    }



    queryWithURL(url?: string): Observable<HttpResponse<Blob>> {
        return this.http.get(url, { observe: 'response', responseType: 'blob' });
    }

    queryDataWithURL(data: any, url?: string): Observable<HttpResponse<Blob>> {
        return this.http.post(url, data, { observe: 'response', responseType: 'blob' });
    }


    findByIdForDownloadAllForClauses(id: number): Observable<HttpResponse<Blob>> {
        let url: string = `${this.downloadAllClausesUrl}/${id}`;
        return this.http.get(url, { observe: 'response', responseType: 'blob' });
    }

    findByIdForDownloadAllForExtensions(id: number): Observable<HttpResponse<Blob>> {
        let url: string = `${this.downloadAllExtensionUrl}/${id}`;
        return this.http.get(url, { observe: 'response', responseType: 'blob' });
    }


    getClauseZip(data: any, url: any): Observable<HttpResponse<Blob>> {
        return this.http.put(this.downloadAllClausesUrl, data, { observe: 'response', responseType: 'blob' });
    }

    getExtensionZip(data: any, url: any): Observable<HttpResponse<Blob>> {
        return this.http.put(SERVER_API_URL + url, data, { observe: 'response', responseType: 'blob' });
    }

    get(url: string): Observable<HttpResponse<any>> {
        return this.http.get<any>(SERVER_API_URL + url, { observe: 'response' });
    }

    getBlob(url: string): Observable<HttpResponse<Blob>> {
        return this.http.get(SERVER_API_URL + url, { observe: 'response', responseType: 'blob' });
    }

    postWithURLAndgetBlob(data, url?: string): Observable<HttpResponse<Blob>> {
        return this.http.post(url, data, { observe: 'response', responseType: 'blob' });
    }

    findCertificateRequestById(id: number): Observable<any> {
        return this.http.get<any>(SERVER_API_URL + 'api/certificate-requests/' + id, { observe: 'response' });
    }


    downloadLetterOfIntentFile(certificateRequestId: number, certificateScopeId: any) {
        return this.http.get(SERVER_API_URL + `api/certificate-request/${certificateRequestId}/scope/${certificateScopeId}/LOI`, { responseType: 'blob' }).map(blob => {
            return blob;
        });
    }

    findVoyageNumberEnabled(): Observable<HttpResponse<any>> {
        return this.http.get(SERVER_API_URL + 'api/check-for-voyage-no', { observe: 'response' });
    }

    // method to check if moc got change before revise
    checkForMOCChange(certificateRequestId) {
        return this.http.get(SERVER_API_URL + 'api/check-for-moc-change/' + Number(certificateRequestId) + '/true', { observe: 'response' });
    }

    findSpotCertificateRequestById(id: number, isRequestToRevise: boolean): Observable<any> {
        return this.http.get<any>(SERVER_API_URL + 'api/spot-client/get-certificate-by-id/' + id + '/' + isRequestToRevise, { observe: 'response' });
    }

    setSurveyAgentToRequest(url, data): Observable<any> {
        return this.http.post(SERVER_API_URL + url, data, { observe: 'response' });
    }

    getAllSurveyCompanies(url) {
        return this.http.get<any>(SERVER_API_URL + url, { observe: 'response' });
    }

    getCertificateClientsByClientId(id: number): Observable<any> {
        return this.http.get<any>(SERVER_API_URL + 'api/certificate-clients-by-client/' + id, { observe: 'response' });
    }

    deleteCertificateClient(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(SERVER_API_URL + 'api/certificate-client/' + id, { observe: 'response' });
    }


    getAllSubscribingInsurers(crid, policyId) {
        return this.http.get<any>(SERVER_API_URL + 'api/policies/get-subscribing-insurers/' + policyId + '/' + crid, { observe: 'response' });
    }

    queryWithIdForFFClient(url?: any, id?: number, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http
            .get(`${this.resourceUrl + url}/${id}`, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));
    }

    queryForCertificateClient(url?: any, req?: any, clientId?: number): Observable<any> {
        const options = createRequestOption(req);
        return this.http
            .get(this.resourceUrl + url + '/' + clientId, { params: options, observe: 'response' });
        // .map((res: any) => this.convertDateArrayFromServer(res));
    }


    getAllCertificateClients(): Observable<any> {
        return this.http.get<any>(`${this.clientAllUrl}`, { observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));
    }

    getCargoSumInsuredLimitFromPolicy(clientId, shipmentDate) {
        return this.http.post<any>(SERVER_API_URL + "api/cargoDetails/get-cargo-sum-insured-limit", { 'clientId': clientId, 'dateOfShipment': shipmentDate }, { observe: 'response' });
    }

    reScreenCertificateClient(data: any) {
        return this.http.post<any>(SERVER_API_URL + 'api/finscan/rescreen-entity', data, { observe: 'response' })
    }
    getCoAssuredPolicyHolder(id: number) {
        return this.http.get<any>(SERVER_API_URL + 'api/policies/coassureds/' + id, { observe: 'response' })
    }

    getCoAssuredPolicy(id: number) {
        return this.http.get<any>(SERVER_API_URL + 'api/coassureds/policies/' + id, { observe: 'response' })
    }

    getCoAssuredPolicyIncludeWar(id: number) {
        return this.http.get<any>(SERVER_API_URL + 'api/coassureds/policies/' + id + "?politicalRiskInvoled=true", { observe: 'response' })
    }


    getMocCoAssuredSelectedPolicy(policyId: number, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get(`${this.resourceUrl + '/get-moc-list-info'}/policy/${policyId}`, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));;
    }

    getMocCoAssuredSelectedPolicyIncludeWar(policyIds: number[], req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get(`${this.resourceUrl + '/get-moc-list-info'}/policy?policyIds=${policyIds}`, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));;
    }


    getCargoSumInsuredLimitByPolicyId(shipmentDate, policyId) {
        return this.http.post<any>(SERVER_API_URL + "api/cargoDetails/get-cargo-sum-insured-limit/policy/" + policyId, { 'dateOfShipment': shipmentDate, policyId: policyId }, { observe: 'response' });
    }

    getCargoListCoAssuredSelectedPolicy(policyId: number, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get(`${this.resourceUrl + '/get-cargo-list-info'}/policy/${policyId}`, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));;
    }

    getCargoListCoAssuredSelectedPolicyIncludeWar(policyIds: number[], req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get(`${this.resourceUrl + '/get-cargo-list-info'}/policies?policyIds=${policyIds}`, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));;
    }

    getCoAssuredPolicyHolderBasedOnPolicy(id: number, policyId: number) {
        return this.http.get<any>(SERVER_API_URL + 'api/policyholder/all/coassureds/' + id + '/exist-in-policy/' + policyId, { observe: 'response' })
    }

    shareCertificateViaEmail(data: any, id: number) {
        return this.http.post<any>(SERVER_API_URL + 'api/send-certificate/' + id, data, { observe: 'response' })
    }

    findVesselNameOrImoMandatoryEnabled(): Observable<HttpResponse<any>> {
        return this.http.get(SERVER_API_URL + 'api/check-for-vessel-name-or-imo-mandatory', { observe: 'response' });
    }

    getFreightForwarderPolicy(id: number) {
        return this.http.get<any>(SERVER_API_URL + 'api/client/policies/' + id, { observe: 'response' })
    }


    getFreightForwarderPolicyForPoliticalRisk(id: number, req?: any) {
        const options = createRequestOption(req);
        return this.http.get<any>(SERVER_API_URL + 'api/client/policies/' + id, { params: options, observe: 'response' })
    }

    getCargoSumInsuredLimitFromPolicyForBulk(clientId, shipmentDate) {
        return this.http.post<any>(SERVER_API_URL + "api/cargoDetails/bulk/get-cargo-sum-insured-limit", { 'clientId': clientId, 'dateOfShipment': shipmentDate }, { observe: 'response' });
    }

    getRejectCertificate(url?: any): Observable<any> {
        return this.http.get<any[]>(url, { observe: 'response' });
    }

    findGoogleLocation(address): Observable<HttpResponse<any>> {
        return this.http.get(SERVER_API_URL + `api/getLocation/${address}`, { observe: 'response' });
    }


    assignCertificateToGroup(groupId: number, certificateRequestId: number): Observable<any> {
        return this.http
            .post<any>(SERVER_API_URL + 'api/certificate-requests/assign-internal-staff-groups', { groupId, certificateRequestId }, { observe: 'response' });
    }

    approveRequest(obj: any): Observable<any> {
        return this.http.post(SERVER_API_URL + 'api/certificate-requests/political-risk/approve', obj, { observe: 'response' });
    }

    rejectRequest(obj: any): Observable<any> {
        return this.http.post(SERVER_API_URL + 'api/certificate-requests/political-risk/reject', obj, { observe: 'response' });
    }

    getCurrentRequestApprovalStatus(certificateReferenceNumber: string, certificateRequestId: number): Observable<any> {
        return this.http.get(SERVER_API_URL + 'api/certificate-requests/political-risk/approval-status?certificateReferenceNumber=' + certificateReferenceNumber + '&certificateRequestId=' + certificateRequestId, { observe: 'response' });
    }

    pushNotificationToInsurer(data: any): Observable<any> {
        return this.http.post<any>(SERVER_API_URL + 'api/certificate-requests/political-risk/send-notification-to-insurer', data, { observe: 'response' });
    }

}
